<template lang="pug">
#content.snap-content
  .overlay(@click="hide()")
  Marquee(:class="{ 'd-none': !whiteLabel }")
  toolBar
  parlayGenerator
  footerNav
</template>


<script>
import toolBar from "@/components/mobile/toolBar";
import parlayGenerator from "@/components/mobile/account/parlayGenerator";
import footerNav from "@/components/mobile/footerNav";

import Marquee from "@/components/mobile/mainPanelControl/marquee";
import config from "@/config";

export default {
  components: {
    toolBar,
    parlayGenerator,
    footerNav,
    Marquee
  },
  computed: {
    whiteLabel() {
      return config.whiteLabel == "1";
    }
  },
  methods: {
    hide(e) {
      var body = $("body");
      if (body.hasClass("snapjs-left")) {
        body.removeClass("snapjs-left");
      }
    }
  }
};
</script>
